// extracted by mini-css-extract-plugin
export default {"sectionForm":"string_sectionForm__Oc8eo","input":"string_input__u-wEq","sectionResult":"string_sectionResult__ME0Ru","button":"string_button__okX7N"};